import React, { useRef } from 'react';
import type { MouseEvent, ReactElement, ReactNode } from 'react';
import { getRandomId } from '../utils/get-random-id';
import { useRootStore } from '../providers/root-store-provider';

export const useConfirmTrigger = (
    children: ReactNode,
    onActivate?: () => void,
): {
    id: string;
    isActive: boolean;
    trigger: ReactNode;
} => {
    const idRef = useRef(getRandomId('confirm'));
    const id = idRef.current;

    const { confirmStore } = useRootStore();
    const isActive = confirmStore.isActive(id);

    const handleClick = (e?: MouseEvent) => {
        if (e) {
            (children as React.ReactElement)?.props?.onClick?.(e);
        }
        confirmStore.setActiveConfirm(id);
        onActivate?.();
    };

    const trigger = React.isValidElement(children) ? (
        React.cloneElement(children as ReactElement, {
            onClick: handleClick,
        })
    ) : (
        <div onClick={handleClick}>{children}</div>
    );

    return { id, isActive, trigger };
};
